module.exports = __webpack_public_path__ + "static/media/logo.059bf68a.png";